// @flow
import React, { useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
// import Icon from '@material-ui/core/Icon';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { makeStyles } from '@material-ui/core/styles';
import { SnackBarState } from "../../reducers/snackbar";
import { closeSnackBar } from "../../actions/snackbar";

const useStyles = makeStyles(theme => ({
  SUCCESS: {
    backgroundColor: '#bedc13',
    color: 'black',
    fontWeight: '500',
    flexWrap: 'nowrap',
  },
  ERROR: {
    fontWeight: '500',
    backgroundColor: theme.palette.error.dark,
    flexWrap: 'nowrap',
  },
  INFO: {
    backgroundColor: theme.palette.primary.main,
    flexWrap: 'nowrap',
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const icon = {
  SUCCESS: CheckCircleIcon,
  ERROR: ErrorIcon,
  INFO: InfoIcon,
};

const MsgSnackbar = () => {
  const snackbar = useSelector((state): SnackBarState => state.snackbar);
  const dispatch = useDispatch();
  const styles = useStyles();
  const Icon = icon[snackbar.type];

  const handleClose = useCallback(
    () => {
      dispatch(closeSnackBar());
    },
    [dispatch],
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={snackbar.open}
      autoHideDuration={snackbar.timeout || 2000}
      onClose={handleClose}
      key={snackbar.msg}
    >
      <SnackbarContent
        className={styles[snackbar.type]}
        aria-describedby="msg-snackbar"
        message={
          <span id="msg-snackbar" className={styles.message} style={{wordBreak: 'break-word'}}>
            <Icon className={`${styles.icon} ${styles.iconVariant}`} />
            {snackbar.msg}
          </span>
        }
        action={[
          <IconButton key="close" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon className={styles.icon} />
          </IconButton>
        ]}
      />
    </Snackbar>
  );
};

MsgSnackbar.defaultProps = {
  timeout: 2000
}

export default MsgSnackbar;
